"use client";

import React, { useCallback, useEffect, useRef, useState } from "react";
import { fontSizes, tableCell, tableInput, tableTextarea, tableTitle } from "./ShippingRequestStyle";
import styles from "./ShippingRequestStyle.css";
import { TransportRequestService } from "@/service/transportRequest";
import { toast } from "react-toastify";


export default function ShippingRequestMainTable({
}) {

  const [formData, setFormData] = useState({});

  const autoCalculatedRef = useRef({
    tongSoKhoi: "",
    tongTrongLuong: "",
  });
  const [moneyFocus, setMoneyFocus] = useState({});

  const normalizeNumberString = useCallback(
    (val) => (val || "").toString().replace(/[^0-9]/g, ""),
    []
  );
  const formatCurrencyVND = (val) => {
    const raw = normalizeNumberString(val);
    if (!raw) return "";
    const withDots = raw.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return `${withDots} vnd`;
  };

  const formatKg = (val) => {
    const raw = normalizeNumberString(val);
    if (!raw) return "";
    const withDots = raw.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return `${withDots} kg`;
  };


  const formatM3 = (val) => {
    const s = (val || "").toString().trim();
    if (!s) return "";
    const num = Number(s);
    if (!isFinite(num)) return "";
    const parts = s.split(".");
    const intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    const decPart = parts[1] ? parts[1] : "";
    const joined = decPart ? `${intPart}.${decPart}` : intPart;
    return `${joined} m3`;
  };

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      const next = { ...prev, [name]: value };

      if (name === "kichThuoc" || name === "soLuong") {
        const parseNumber = (v) => {
          if (v === undefined || v === null) return 0;
          const s = String(v).trim().replace(",", ".");
          const n = parseFloat(s);
          return isNaN(n) ? 0 : n;
        };

        const raw = next.kichThuoc || "";
        const parts = raw
          .toString()
          .replace(/\s+/g, "")
          .split(/[xX*×]/)
          .map((p) => p.replace(",", "."))
          .filter((p) => p.length > 0);

        if (parts.length >= 3) {
          const dai = parseNumber(parts[0]);
          const rong = parseNumber(parts[1]);
          const cao = parseNumber(parts[2]);
          const soLuong = parseNumber(next.soLuong);
          const volume = dai * rong * cao * (soLuong || 1);
          next.tongSoKhoi = volume > 0 ? String(Number(volume.toFixed(3))) : "";
        }
      }
      return next;
    });
  }, []);

  const parseDimsProductM3 = (dims) => {
    if (!dims) return null;
    const parts = dims.toString().toLowerCase().replace(/\s+/g, "").split(/[x×*]/);
    const nums = parts?.map((p) => parseFloat(p)).filter((n) => !isNaN(n));
    if (nums.length < 3) return null;
    return nums.slice(0, 3).reduce((acc, n) => acc * n, 1);
  };

  useEffect(() => {
    try {
      const perItemM3 = parseDimsProductM3(formData.kichThuoc);
      if (perItemM3 == null) {
        autoCalculatedRef.current.tongSoKhoi = "";
        return;
      }
      const qty = Number((formData.soLuong || "").toString().replace(/[^0-9]/g, "")) || 1;
      const totalM3 = perItemM3 * qty;
      let display = totalM3.toFixed(3);
      display = display.replace(/\.0+$/, "").replace(/(\.[0-9]*?)0+$/, "$1");

      const current = (formData.tongSoKhoi || "").toString();
      const previousAuto = autoCalculatedRef.current.tongSoKhoi;
      autoCalculatedRef.current.tongSoKhoi = display;

      const shouldUpdate =
        current === "" ||
        previousAuto === undefined ||
        previousAuto === null ||
        current === previousAuto;

      if (shouldUpdate && current !== display) {
        handleChange({ target: { name: "tongSoKhoi", value: display }, __internal: true });
      }
    } catch (_) {
      autoCalculatedRef.current.tongSoKhoi = "";
    }
  }, [formData.kichThuoc, formData.soLuong, formData.tongSoKhoi, handleChange, autoCalculatedRef]);

  useEffect(() => {
    try {
      const qty = Number(normalizeNumberString(formData.soLuong));
      const perKg = Number(normalizeNumberString(formData.trongLuong));
      if (!qty || !perKg) {
        autoCalculatedRef.current.tongTrongLuong = "";
        return;
      }
      const totalKg = qty * perKg;
      const desired = totalKg.toString();

      const current = (formData.tongTrongLuong || "").toString();
      const previousAuto = autoCalculatedRef.current.tongTrongLuong;
      autoCalculatedRef.current.tongTrongLuong = desired;

      const shouldUpdate =
        current === "" ||
        previousAuto === undefined ||
        previousAuto === null ||
        current === previousAuto;

      if (shouldUpdate && current !== desired) {
        handleChange({ target: { name: "tongTrongLuong", value: desired }, __internal: true });
      }
    } catch (_) {
      autoCalculatedRef.current.tongTrongLuong = "";
    }
  }, [
    formData.soLuong,
    formData.trongLuong,
    formData.tongTrongLuong,
    handleChange,
    normalizeNumberString,
    autoCalculatedRef,
  ]);

  const handleMoneyChange = (name) => (e) => {
    const raw = normalizeNumberString(e.target.value);
    handleChange({ target: { name, value: raw } });
  };

  const handleMoneyFocus = (name) => () => {
    setMoneyFocus((prev) => ({ ...prev, [name]: true }));
  };

  const handleMoneyBlur = (name) => () => {
    setMoneyFocus((prev) => ({ ...prev, [name]: false }));
  };

  const formatDateForInput = (val) => {
    if (!val) {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }
    const v = val.toString().trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(v)) {
      return v;
    }
    if (/^\d{2}-\d{2}-\d{4}$/.test(v)) {
      const [d, m, y] = v.split("-");
      return `${y}-${m}-${d}`;
    }
    try {
      const d = new Date(v);
      if (!isNaN(d)) {
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      }
    } catch (_) { }
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleSubmit = async () => {
    try {
      if (!formData.priceAgreement) {
        toast.warning("Vui lòng điền đầy đủ thông tin bắt buộc.");
        return;
      }
      await TransportRequestService.submit(formData);
      toast.success("Yêu cầu vận chuyển đã được gửi thành công!");

      setFormData({});
      setMoneyFocus({});
    } catch (error) {
      console.error(error);
      toast.error("Gửi yêu cầu thất bại: " + (error.message || "Có lỗi xảy ra"));
    }
  };


  return (
    <div style={{ marginBottom: "0" }} className={styles.quoteTable}>
      <div className="quote-table-wrapper">
        <table
          className="quote-table"
          style={{ width: "100%", border: "1px solid #000", borderCollapse: "collapse" }}>
          <tbody>
            {/* Header row as first row in tbody to prevent repeating */}
            <tr className="table-header-row">
              <td
                colSpan={6}
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  textAlign: "center",
                  fontSize: fontSizes.tableHeader,
                  fontWeight: "bold",
                  verticalAlign: "middle",
                  background: "#ffffffff",
                }}
              >
                PHIẾU YÊU CẦU VẬN CHUYỂN HÀNG HÓA
              </td>
            </tr>
            <tr className="table-header-row">
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  textAlign: "center",
                  fontSize: fontSizes.title,
                  fontWeight: "bold",
                  verticalAlign: "middle",
                  background: "#FDE9D9",
                  width: "20%",
                }}>
                SỐ CHỨNG TỪ
              </td>
              <td
                colSpan={2}
                style={{
                  ...tableCell,
                  width: "30%",
                  padding: 0,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    minHeight: "40px",
                    width: "100%",
                  }}
                >
                  <input
                    type="text"
                    name="soChungTu"
                    value={formData.soChungTu || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, soChungTu: e.target.value })
                    }
                    placeholder="Nhập số chứng từ"
                    style={{
                      ...tableTextarea,
                    }}
                  />
                </div>
              </td>

              <td
                style={{
                  ...tableTitle,
                  width: "20%",
                }}>
                NGÀY GỬI HÀNG
              </td>
              <td
                colSpan={2}
                style={{
                  ...tableCell,
                  background: "#fcff58ff",
                  width: "30%",
                  padding: 0,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    minHeight: "40px",
                    width: "100%",
                  }}
                >
                  <input
                    type="date"
                    name="daySendQuote"
                    value={formatDateForInput(formData.daySendQuote)}
                    onChange={handleChange}
                    style={{
                      border: "none",
                      outline: "none",
                      fontSize: fontSizes.title,
                      textAlign: "center",
                      fontStyle: "italic",
                      width: "100%",
                      background: "transparent",
                      padding: "6px 8px",
                    }}
                  />
                </div>
              </td>


            </tr>
            <tr className="table-header-row">
              <td
                colSpan={3}
                style={{
                  ...tableTitle,
                  width: "50%",
                }}>
                THÔNG TIN NGƯỜI GỬI HÀNG
              </td>
              <td
                colSpan={3}
                style={{
                  ...tableTitle,
                  width: "50%",
                }}>
                THÔNG TIN NGƯỜI NHẬN HÀNG
              </td>
            </tr>

            <tr className="table-header-row">
              <td
                style={{
                  ...tableCell,
                  width: "15%",
                }}>
                KHÁCH HÀNG/CTY
              </td>
              <td
                colSpan={2}
                style={{
                  ...tableInput,
                  width: "30%",
                }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    minHeight: "40px",
                    width: "100%",
                  }}
                >
                  <input
                    type="text"
                    name="customerName"
                    value={formData.customerName || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, customerName: e.target.value })
                    }
                    placeholder="Nhập tên khách hàng/cty"
                    style={{
                      ...tableTextarea,
                    }}
                  />
                </div>
              </td>
              <td
                style={{
                  ...tableCell,
                  width: "15%",
                }}>
                DỰ ÁN / CTY / KH
              </td>
              <td
                colSpan={2}
                style={{
                  ...tableInput,
                  width: "30%",
                }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    minHeight: "40px",
                    width: "100%",
                  }}
                >
                  <input
                    type="text"
                    name="projectCompany"
                    value={formData.projectCompany || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, projectCompany: e.target.value })
                    }
                    placeholder="Nhập tên dự án/cty/khách hàng"
                    style={{
                      ...tableTextarea,
                    }}
                  />
                </div>
              </td>
            </tr>

            <tr className="table-header-row">
              <td
                style={{
                  ...tableCell,
                  width: "15%",
                }}>
                ĐỊA CHỈ GỬI HÀNG
              </td>
              <td
                colSpan={2}
                style={{
                  ...tableInput,
                  width: "30%",
                }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    minHeight: "40px",
                    width: "100%",
                  }}
                >
                  <input
                    type="text"
                    name="senderAddress"
                    value={formData.senderAddress || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, senderAddress: e.target.value })
                    }
                    placeholder="Nhập địa chỉ gửi hàng"
                    style={{
                      ...tableTextarea,
                    }}
                  />
                </div>
              </td>
              <td
                style={{
                  ...tableCell,
                  width: "15%",
                }}>
                Đ/C NHẬN HÀNG
              </td>
              <td
                colSpan={2}
                style={{
                  ...tableInput,
                  width: "30%",
                }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    minHeight: "40px",
                    width: "100%",
                  }}
                >
                  <input
                    type="text"
                    name="receiverAddress"
                    value={formData.receiverAddress || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, receiverAddress: e.target.value })
                    }
                    placeholder="Nhập địa chỉ nhận hàng"
                    style={{
                      ...tableTextarea,
                    }}
                  />
                </div>
              </td>
            </tr>

            <tr className="table-header-row">
              <td
                style={{
                  ...tableCell,
                  width: "15%",
                }}>
                ĐIỆN THOẠI
              </td>
              <td
                colSpan={2}
                style={{
                  ...tableInput,
                  width: "30%",
                }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    minHeight: "40px",
                    width: "100%",
                  }}
                >
                  <input
                    type="text"
                    name="senderPhone"
                    value={formData.senderPhone || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, senderPhone: e.target.value })
                    }
                    placeholder="Nhập số điện thoại gửi hàng"
                    style={{
                      ...tableTextarea,
                    }}
                  />
                </div>
              </td>
              <td
                style={{
                  ...tableCell,
                  width: "15%",
                }}>
                ĐIỆN THOẠI
              </td>
              <td
                colSpan={2}
                style={{
                  ...tableInput,
                  width: "30%",
                }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    minHeight: "40px",
                    width: "100%",
                  }}
                >
                  <input
                    type="text"
                    name="receiverPhone"
                    value={formData.receiverPhone || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, receiverPhone: e.target.value })
                    }
                    placeholder="Nhập số điện thoại nhận hàng"
                    style={{
                      ...tableTextarea,
                    }}
                  />
                </div>
              </td>
            </tr>

            <tr className="table-header-row">
              <td
                style={{
                  ...tableCell,
                  width: "15%",
                }}>
                NGƯỜI LIÊN HỆ
              </td>
              <td
                colSpan={2}
                style={{
                  width: "30%",
                }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    minHeight: "40px",
                    width: "100%",
                  }}
                >
                  <input
                    type="text"
                    name="contactPersonSender"
                    value={formData.contactPersonSender || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, contactPersonSender: e.target.value })
                    }
                    placeholder="Nhập người liên hệ gửi hàng"
                    style={{
                      ...tableTextarea,
                    }}
                  />
                </div>
              </td>
              <td
                style={{
                  ...tableCell,
                  width: "15%",
                }}>
                NGƯỜI LIÊN HỆ
              </td>
              <td
                colSpan={2}
                style={{
                  width: "30%",
                }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    minHeight: "40px",
                    width: "100%",
                  }}
                >
                  <input
                    type="text"
                    name="contactPersonReceiver"
                    value={formData.contactPersonReceiver || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, contactPersonReceiver: e.target.value })
                    }
                    placeholder="Nhập người liên hệ nhận hàng"
                    style={{
                      ...tableTextarea,
                    }}
                  />
                </div>
              </td>
            </tr>

            <tr className="table-header-row">
              <td
                colSpan={6}
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  textAlign: "left",
                  fontSize: fontSizes.title,
                  fontWeight: "bold",
                  verticalAlign: "middle",
                  background: "#FDE9D9",
                  width: "100%",
                }}>
                I. CHI TIẾT HÀNG HÓA VẬN CHUYỂN
              </td>
            </tr>

            <tr className="table-header-row">
              <td
                style={{
                  ...tableCell,
                  width: "15%",
                }}>
                MẶT HÀNG
              </td>
              <td
                style={{
                  ...tableCell,
                  width: "15%",
                }}>
                SỐ LƯỢNG
              </td>
              <td
                style={{
                  ...tableCell,
                  width: "15%",
                }}>
                TRỌNG LƯỢNG
              </td>
              <td
                style={{
                  ...tableCell,
                  width: "15%",
                }}>
                SỐ KHỐI
              </td>
              <td
                colSpan={2}
                style={{
                  ...tableCell,
                  width: "30%",
                }}>
                CHI TIẾT KHÁC
              </td>
            </tr>

            <tr className="table-header-row">
              <td
                style={{
                  ...tableInput,
                  width: "15%",
                }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    minHeight: "40px",
                    width: "100%",
                  }}
                >
                  <input
                    type="text"
                    name="productName"
                    value={formData.productName || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, productName: e.target.value })
                    }
                    placeholder="Nhập tên mặt hàng"
                    style={{
                      ...tableTextarea,
                    }}
                  />
                </div>
              </td>
              <td
                style={{
                  ...tableInput,
                  width: "15%",
                }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    minHeight: "40px",
                    width: "100%",
                  }}
                >
                  <input
                    type="text"
                    name="quantity"
                    value={formData.quantity || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, quantity: e.target.value })
                    }
                    placeholder="Nhập số lượng"
                    style={{
                      ...tableTextarea,
                    }}
                  />
                </div>
              </td>
              <td
                style={{
                  ...tableInput,
                  width: "15%",
                }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    minHeight: "40px",
                    width: "100%",
                  }}
                >
                  <input
                    type="text"
                    name="weight"
                    value={
                      moneyFocus.weight
                        ? formData.weight || ""
                        : formatKg(formData.weight)
                    }
                    onChange={handleMoneyChange("weight")}
                    onFocus={handleMoneyFocus("weight")}
                    onBlur={handleMoneyBlur("weight")}
                    placeholder="Nhập trọng lượng"
                    style={{
                      ...tableTextarea,
                    }}
                  />
                </div>
              </td>
              <td
                style={{
                  ...tableInput,
                  width: "15%",
                }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    minHeight: "40px",
                    width: "100%",
                  }}
                >
                  <input
                    type="text"
                    name="volume"
                    value={
                      moneyFocus.volume
                        ? formData.volume || ""
                        : formatM3(formData.volume)
                    }
                    onChange={handleMoneyChange("volume")}
                    onFocus={handleMoneyFocus("volume")}
                    onBlur={handleMoneyBlur("volume")}
                    placeholder="Nhập số khối"
                    style={{
                      ...tableTextarea,
                    }}
                  />
                </div>
              </td>
              <td
                colSpan={2}
                style={{
                  ...tableInput,
                  width: "30%",
                }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    minHeight: "40px",
                    width: "100%",
                  }}
                >
                  <input
                    type="text"
                    name="otherDetails"
                    value={formData.otherDetails || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, otherDetails: e.target.value })
                    }
                    placeholder="Nhập chi tiết khác"
                    style={{
                      ...tableTextarea,
                    }}
                  />
                </div>
              </td>
            </tr>

            <tr className="table-header-row">
              <td
                colSpan={6}
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  textAlign: "left",
                  fontSize: fontSizes.title,
                  fontWeight: "bold",
                  verticalAlign: "middle",
                  background: "#FDE9D9",
                  width: "100%",
                }}>
                II. THỎA THUẬN VẬN CHUYỂN
              </td>
            </tr>

            <tr className="table-header-row">
              <td
                style={{
                  ...tableCell,
                  width: "15%",
                  fontStyle: "italic",
                }}>
                Đơn giá không bao gồm:
              </td>
              <td
                colSpan={5}
                style={{
                  border: "1px solid #000",
                  padding: "2px",
                  textAlign: "left",
                  fontSize: fontSizes.table,
                  fontWeight: "normal",
                  verticalAlign: "middle",
                  width: "85%",
                }}>
                Thuế GTGT 08%; Phí bốc xếp nâng hạ tại nơi gửi; Phí bốc xếp tại nơi đến; Không bao phí vào đường cấm + đường lún + đường nhỏ + đường hẹp; Không bao phí trung chuyển xe tải nhỏ sang xe để đi giao hàng hoặc đi nhận hàng; Phí lưu xe; Phí bồi dưỡng giao nhận hàng; Phí ra vào cảng + vào cổng + vào bến xe + bãi xe + chành xe. [Đối với mặt hàng là Kính, đá hoa cương, gạch men, gốm sứ, thủy tinh ... trong quá trình vận chuyển nếu có bể vỡ bên vận chuyển không bồi thường; trừ trường hợp có mua bảo hiểm hàng hóa].
              </td>
            </tr>

            <tr className="table-header-row">
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  textAlign: "left",
                  fontSize: fontSizes.table,
                  fontWeight: "normal",
                  verticalAlign: "middle",
                  width: "15%",
                  fontStyle: "italic",
                }}>
                Đơn giá đã bao gồm:
              </td>
              <td
                colSpan={5}
                style={{
                  border: "1px solid #000",
                  padding: "8px 2px",
                  textAlign: "left",
                  fontSize: fontSizes.table,
                  fontWeight: "bold",
                  verticalAlign: "middle",
                  width: "85%",
                  color: "#ff0000",
                }}>
                Cước vận chuyển từ Kho CRB HCM đến Kho CRB Phú Quốc =?
              </td>
            </tr>

            <tr className="table-header-row">
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  textAlign: "left",
                  fontSize: fontSizes.table,
                  fontWeight: "normal",
                  verticalAlign: "middle",
                  width: "15%",
                  fontStyle: "italic",
                }}>
                Phát sinh nếu có:
              </td>
              <td
                colSpan={5}
                style={{
                  border: "1px solid #000",
                  padding: "2px",
                  textAlign: "left",
                  fontSize: fontSizes.table,
                  fontWeight: "normal",
                  verticalAlign: "middle",
                  width: "85%",
                }}>
                Giải thích từ ngữ &quot;bốc xếp&quot;: Nếu trong báo giá của Con Rùa Biển có liên quan đến phần bốc xếp đã bao gồm vào giá thì mặc định việc bốc xếp từ xe xuống đất hay từ dưới đất lên xe điều xác định trong bán kính 10m kể từ vị trí xe tải lớn đậu được. Nếu việc bốc xếp đi xa hơn 10m thì sẽ phát sinh chi phí bốc xếp tăng thêm do Bên Thuê Vận Chuyển chịu.
              </td>
            </tr>

            <tr className="table-header-row">
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  textAlign: "left",
                  fontSize: fontSizes.table,
                  fontWeight: "bold",
                  verticalAlign: "middle",
                  width: "15%",
                  color: "#ff0000",
                  fontStyle: "italic",
                }}>
                Yêu cầu của người gửi:
              </td>
              <td
                colSpan={5}
                style={{
                  width: "85%",
                }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    minHeight: "40px",
                    width: "100%",
                  }}
                >
                  <input
                    type="text"
                    name="senderRequests"
                    value={formData.senderRequests || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, senderRequests: e.target.value })
                    }
                    placeholder="Nhập yêu cầu của người gửi"
                    style={{
                      ...tableTextarea,
                    }}
                  />
                </div>
              </td>
            </tr>

            <tr className="table-header-row">
              <td
                colSpan={6}
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  textAlign: "left",
                  fontSize: fontSizes.title,
                  fontWeight: "bold",
                  verticalAlign: "middle",
                  background: "#FDE9D9",
                  width: "100%",
                }}>
                III. GIÁ CẢ VÀ PHƯƠNG THỨC THANH TOÁN
              </td>
            </tr>

            <tr className="table-header-row">
              <td
                colSpan={2}
                style={{
                  ...tableCell,
                  width: "30%",
                }}>
                GIÁ VẬN CHUYỂN THỎA THUẬN
              </td>
              <td
                colSpan={2}
                style={{
                  ...tableCell,
                  width: "30%",
                }}>
                THỜI HẠN THANH TOÁN
              </td>
              <td
                colSpan={2}
                style={{
                  ...tableCell,
                  width: "30%",
                }}>
                HÌNH THỨC THANH TOÁN
              </td>
            </tr>

            <tr className="table-header-row">
              <td
                colSpan={2}
                style={{
                  width: "30%",
                }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    minHeight: "40px",
                    width: "100%",
                  }}
                >
                  <input
                    type="text"
                    name="priceAgreement"
                    value={
                      moneyFocus.priceAgreement
                        ? formData.priceAgreement || ""
                        : formatCurrencyVND(formData.priceAgreement)
                    }
                    onChange={handleMoneyChange("priceAgreement")}
                    onFocus={handleMoneyFocus("priceAgreement")}
                    onBlur={handleMoneyBlur("priceAgreement")}
                    placeholder="Nhập giá vận chuyển thỏa thuận"
                    style={{
                      ...tableTextarea,
                    }}
                  />
                </div>
              </td>
              <td
                colSpan={2}
                style={{
                  ...tableCell,
                  width: "30%",
                }}>
                Thanh toán 100% cước vận chuyển ngay khi hàng đến nơi người nhận
              </td>
              <td
                colSpan={2}
                style={{
                  ...tableCell,
                  width: "30%",
                }}>
                Chuyển khoản hoặc tiền mặt trực tiếp lái xe.
              </td>
            </tr>

            <tr className="table-header-row">
              <td
                colSpan={6}
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  textAlign: "left",
                  fontSize: fontSizes.title,
                  fontWeight: "bold",
                  verticalAlign: "middle",
                  background: "#FDE9D9",
                  width: "100%",
                }}>
                IV. THÔNG TIN THANH TOÁN CƯỚC VẬN CHUYỂN
              </td>
            </tr>

            <tr className="table-header-row">
              <td
                colSpan={3}
                style={{
                  ...tableCell,
                  width: "50%",
                }}>
                THÔNG TIN LIÊN HỆ ĐỂ THU TIỀN VẬN CHUYỂN
              </td>
              <td
                colSpan={3}
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  textAlign: "center",
                  fontSize: fontSizes.table,
                  fontWeight: "bold",
                  verticalAlign: "middle",
                  width: "50%",
                  color: "#ff0000",
                }}>
                THÔNG TIN XUẤT HÓA ĐƠN (NẾU CÓ LẤY HÓA ĐƠN GTGT)
              </td>
            </tr>

            <tr className="table-header-row">
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  textAlign: "left",
                  fontSize: fontSizes.table,
                  fontWeight: "normal",
                  verticalAlign: "middle",
                  width: "15%",
                }}>
                Liên hệ với ai để thu tiền ?
              </td>
              <td
                colSpan={2}
                style={{
                  width: "30%",
                }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    minHeight: "40px",
                    width: "100%",
                  }}
                >
                  <input
                    type="text"
                    name="paymentPerson"
                    value={formData.paymentPerson || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, paymentPerson: e.target.value })
                    }
                    placeholder="Nhập người thanh toán"
                    style={{
                      ...tableTextarea,
                    }}
                  />
                </div>
              </td>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  textAlign: "left",
                  fontSize: fontSizes.table,
                  fontWeight: "bold",
                  verticalAlign: "middle",
                  width: "15%",
                }}>
                TÊN CTY:
              </td>
              <td
                colSpan={2}
                style={{
                  width: "30%",
                }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    minHeight: "40px",
                    width: "100%",
                  }}
                >
                  <input
                    type="text"
                    name="companyInvoice"
                    value={formData.companyInvoice || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, companyInvoice: e.target.value })
                    }
                    placeholder="Nhập tên công ty"
                    style={{
                      ...tableTextarea,
                    }}
                  />
                </div>
              </td>
            </tr>

            <tr className="table-header-row">
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  textAlign: "left",
                  fontSize: fontSizes.table,
                  fontWeight: "normal",
                  verticalAlign: "middle",
                  width: "15%",
                }}>
                Gọi số điện thoại để thu tiền ?
              </td>
              <td
                colSpan={2}
                style={{
                  ...tableInput,
                  width: "30%",
                }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    minHeight: "40px",
                    width: "100%",
                  }}
                >
                  <input
                    type="text"
                    name="paymentPhone"
                    value={formData.paymentPhone || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, paymentPhone: e.target.value })
                    }
                    placeholder="Nhập số điện thoại thanh toán"
                    style={{
                      ...tableTextarea,
                    }}
                  />
                </div>
              </td>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  textAlign: "left",
                  fontSize: fontSizes.table,
                  fontWeight: "bold",
                  verticalAlign: "middle",
                  width: "15%",
                }}>
                ĐỊA CHỈ:
              </td>
              <td
                colSpan={2}
                style={{
                  ...tableInput,
                  width: "30%",
                }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    minHeight: "40px",
                    width: "100%",
                  }}
                >
                  <input
                    type="text"
                    name="addressInvoice"
                    value={formData.addressInvoice || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, addressInvoice: e.target.value })
                    }
                    placeholder="Nhập địa chỉ hóa đơn"
                    style={{
                      ...tableTextarea,
                    }}
                  />
                </div>
              </td>
            </tr>

            <tr className="table-header-row">
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  textAlign: "left",
                  fontSize: fontSizes.table,
                  fontWeight: "normal",
                  verticalAlign: "middle",
                  width: "15%",
                }}>
                Email nhận hóa đơn điện tử ?
              </td>
              <td
                colSpan={2}
                style={{
                  ...tableInput,
                  width: "30%",
                }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    minHeight: "40px",
                    width: "100%",
                  }}
                >
                  <input
                    type="text"
                    name="emailInvoice"
                    value={formData.emailInvoice || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, emailInvoice: e.target.value })
                    }
                    placeholder="Nhập email nhận hóa đơn điện tử"
                    style={{
                      ...tableTextarea,
                    }}
                  />
                </div>
              </td>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  textAlign: "left",
                  fontSize: fontSizes.table,
                  fontWeight: "bold",
                  verticalAlign: "middle",
                  width: "15%",
                }}>
                MST:
              </td>
              <td
                colSpan={2}
                style={{
                  ...tableInput,
                  width: "30%",
                }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    minHeight: "40px",
                    width: "100%",
                  }}
                >
                  <input
                    type="text"
                    name="taxCode"
                    value={formData.taxCode || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, taxCode: e.target.value })
                    }
                    placeholder="Nhập mã số thuế"
                    style={{
                      ...tableTextarea,
                    }}
                  />
                </div>
              </td>
            </tr>

            <tr className="table-header-row">
              <td
                colSpan={2}
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  textAlign: "center",
                  fontSize: fontSizes.title,
                  fontWeight: "bold",
                  verticalAlign: "middle",
                  background: "#FDE9D9",
                }}>
                BÊN THUÊ VẬN CHUYỂN
              </td>
              <td
                colSpan={2}
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  textAlign: "center",
                  fontSize: fontSizes.title,
                  fontWeight: "bold",
                  verticalAlign: "middle",
                  background: "#FDE9D9",
                  width: "30%",
                }}>
                THỎA THUẬN VẬN CHUYỂN
              </td>
              <td
                colSpan={2}
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  textAlign: "center",
                  fontSize: fontSizes.title,
                  fontWeight: "bold",
                  verticalAlign: "middle",
                  background: "#FDE9D9",
                  width: "30%",
                }}>
                BÊN VẬN CHUYỂN <span style={{ color: "red" }}>CON RÙA BIỂN</span> XÁC NHẬN
              </td>
            </tr>

            <tr className="table-header-row">
              <td
                colSpan={2}
                style={{
                  ...tableCell,
                  width: "30%",
                }}>
                (KÝ VÀ GHI RÕ HỌ TÊN)
              </td>
              <td
                colSpan={2}
                style={{
                  ...tableCell,
                  width: "30%",
                }}>
                MỘT SỐ NỘI DUNG QUAN TRỌNG
              </td>
              <td
                style={{
                  ...tableCell,
                  width: "15%",
                }}>
                SỐ TIỀN THANH TOÁN
              </td>
              <td
                style={{
                  ...tableCell,
                  width: "15%",
                }}>
                HÌNH THỨC
              </td>
            </tr>

            <tr className="table-header-row">
              <td
                colSpan={2}
                style={{
                  ...tableCell,
                  width: "30%",
                }}>
              </td>
              <td
                colSpan={2}
                style={{
                  ...tableCell,
                  width: "30%",
                }}
              >
                <p style={{ margin: "0 0 10px 0", fontStyle: "italic" }}>
                  (Quý khách hàng cần nên ký hợp đồng vận chuyển với Con Rùa Biển để được hưởng nhiều ưu đãi cũng như là các điều khoản ràng buộc trong hợp đồng có lợi cho Quý khách hàng.)
                </p>

                <p style={{ margin: "0 0 5px 0", textAlign: "center", fontSize: "11px", fontWeight: "bold", color: "#ff0000" }}>
                  CĂN CỨ THEO HỢP ĐỒNG VẬN CHUYỂN
                </p>

                <p style={{ margin: "0", fontWeight: "bold", fontSize: "12px", textAlign: "left", color: "#ff0000" }}>
                  SỐ: …………………………
                </p>

                <p style={{ fontWeight: "bold", marginBottom: "0", fontSize: "12px", textAlign: "left", color: "#ff0000" }}>
                  NGÀY KÝ HĐ: ………………
                </p>
              </td>
              <td colSpan={2} style={{ padding: 0, height: "20px" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", height: "100%" }}>
                  <tbody style={{ height: "100%" }}>
                    <tr style={{ height: "20%" }}>
                      <td
                        style={{
                          padding: "8px",
                          textAlign: "center",
                          fontSize: fontSizes.table,
                          fontWeight: "bold",
                          verticalAlign: "middle",
                          width: "50%",
                        }}
                      >
                        {formData.priceAgreement
                          ? `${(Number(formData.priceAgreement) * 1.08).toLocaleString("vi-VN")} VNĐ (Đã VAT 8%)`
                          : "0 VNĐ (Đã VAT 8%)"}
                      </td>

                      <td
                        style={{
                          borderLeft: "1px solid #000",
                          padding: "0",
                          verticalAlign: "middle",
                          width: "50%",
                        }}
                      >
                        <select
                          name="paymentMethod"
                          value={formData.paymentMethod || ""}
                          onChange={handleChange}
                          style={{
                            ...tableTextarea,
                            width: "100%",
                            border: "none",
                            outline: "none",
                            height: "100%",
                            lineHeight: "1.5",
                          }}
                        >
                          <option value="">Phương thức</option>
                          <option value="transfer">Chuyển khoản</option>
                          <option value="cash">Tiền mặt</option>
                        </select>
                      </td>

                    </tr>

                    <tr style={{ height: "50%" }}>
                      <td
                        colSpan={2}
                        style={{
                          borderTop: "1px solid #000",
                          padding: "8px",
                          textAlign: "center",
                          height: "100%",
                        }}
                      ></td>
                    </tr>
                  </tbody>
                </table>
              </td>

            </tr>

            <tr className="table-header-row">
              <td
                colSpan={6}
                style={{
                  ...tableCell,
                  fontSize: "12px !important",
                  width: "100%",
                }}>
                PHIẾU NÀY CÓ GIÁ TRỊ LÀM CĂN CỨ ĐỂ VẬN CHUYỂN VÀ YÊU CẦU THANH TOÁN CỦA &quot;<span style={{ color: "red" }}>CON RÙA BIỂN</span>&quot; VỚI NGƯỜI GỬI
              </td>
            </tr>
          </tbody>
        </table>

        <div className="mt-4 flex justify-end">
          <button
            onClick={handleSubmit}
            className="bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-6 rounded shadow"
          >
            Xác nhận gửi yêu cầu
          </button>
        </div>
      </div>
    </div>
  );
}
